import React, { memo, useState } from 'react';
import { useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import EcomPolicyModal from 'layouts/DetailsPage/components/ProductInfo/Mobile/components/EcomPolicy/components/EcomPolicyModal';

import {
  getNewEcomPolicies,
  getProductId,
  getProductData,
} from 'store/details/selectors';
import { IEcomPolicyKey } from 'store/details/types';
import { getSelectedVendorId, resolveVendorId } from 'shared/helpers/multiSeller';
import { NO_RETURN_EXCHANGE_TEXT } from 'shared/components/EstimatedDeliveryDetails/constants';

import PolicyCard from './PolicyCard';
import { Grid } from './styles';

const PolicyCards = () => {
  const [openModal, setOpenModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState<IEcomPolicyKey>();
  const defaultEcomPolicies = useSelector(getNewEcomPolicies);
  const productId = useSelector(getProductId);
  const product = useSelector(getProductData);
  const selectedSKU = useSelector((state: any) => state.details.selectedSKU);
  const selectedVendorId = getSelectedVendorId(selectedSKU, product?.vendor_id);
  const resolvedVendorId = resolveVendorId(
    selectedSKU?.view_more_section?.vendors,
    selectedVendorId,
    product?.vendor_id
  );
  const selectedSkuEcomPolicies = selectedSKU?.ecom_policies;
  const ecomPolicies =
    selectedSkuEcomPolicies && selectedSkuEcomPolicies.length
      ? selectedSkuEcomPolicies
      : defaultEcomPolicies;

  if (isEmpty(ecomPolicies)) return null;

  return (
    <>
      <Grid data-test="policy-cards-v3">
        {ecomPolicies.map((policy: ProductDetail.IVendorEcomPolicy) => (
          <PolicyCard
            key={policy.policy_name}
            icon={policy.image}
            text={policy.text}
            onClick={() => {
              if (
                !policy.text.toLowerCase().includes(NO_RETURN_EXCHANGE_TEXT.toLowerCase())
              ) {
                setSelectedItem(policy.policy_name as IEcomPolicyKey);
                setOpenModal(true);
              }
            }}
          />
        ))}
      </Grid>
      {openModal && selectedItem && (
        <EcomPolicyModal
          productId={selectedSKU?.id || productId}
          selectedItem={selectedItem}
          modalOpen={openModal}
          onClose={() => setOpenModal(false)}
          vendorCode={resolvedVendorId}
          vendorType={selectedSKU?.view_more_section?.vendors?.[resolvedVendorId]?.vendor_type || selectedSKU?.vendor_type || product?.vendor_type}
          key={selectedItem}
        />
      )}
    </>
  );
};

export default memo(PolicyCards);
